module.exports = __webpack_public_path__ + "assets/img/kt-renewed-4.5f9f4b6c.png";